import React from "react";
import { WhatsAppIcon, waUrl } from "./WhatsAppButton";
import { hotel } from "../mock";

// Mobile-only sticky bottom CTA — elegant "Rezervasyon • WhatsApp"
const StickyMobileCTA = () => {
  const href = waUrl(`${hotel.whatsappIntro} Müsaitlik ve fiyat bilgisi rica ediyorum.`);
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp üzerinden hızlı rezervasyon"
      className="md:hidden fixed bottom-0 left-0 right-0 z-[95] bg-[#2b2620] text-white flex items-center justify-center gap-3 py-4 shadow-[0_-8px_24px_-10px_rgba(0,0,0,0.5)] active:bg-[#221e18]"
    >
      <span className="text-[#25d366] flex items-center">
        <WhatsAppIcon size={20} />
      </span>
      <span className="text-[0.82rem] uppercase tracking-[0.16em] font-500">
        Rezervasyon Yap
      </span>
      <span className="w-px h-4 bg-white/25" />
      <span className="text-[11px] text-white/60 tracking-wide normal-case">
        WhatsApp'tan hızlı
      </span>
    </a>
  );
};

export default StickyMobileCTA;
